import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { navigateToSitecorePage } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.AnsvarPrivat,
        tekst: 'Privatperson',
    },
    {
        id: KategoriSvarId.AnsvarLandbruk,
        tekst: 'Landbruk',
    },
    {
        id: KategoriSvarId.AnsvarNaring,
        tekst: 'Næring',
    },
];

export const Ansvar = () => {
    const { url } = useConfig().links.ansvarlandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.AnsvarPrivat) {
            navigate(urler().ansvarPrivatUrl);
        } else {
            navigate(urler().ansvarLandbrukNaringUrl);
        }
    };

    return (
        <GruppeLandingsside
            title="Ansvar"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            radioButtonsLabel="Skal du melde skaden for privatperson eller foretak?"
            kategoriId="ansvar"
        />
    );
};
